/* v8 ignore next */
import { combineEpics } from 'redux-observable';

/* v8 ignore next */
import OrderEpics from './order';
/* v8 ignore next */
import PaymentEpics from './payment';
/* v8 ignore next */
import GuestEpics from './guest';

/* v8 ignore next */
export const epicsArray = [...OrderEpics, ...PaymentEpics, ...GuestEpics];
/* v8 ignore next */
const combinedEpics = combineEpics(...epicsArray);

/* v8 ignore next */
export default combinedEpics;
